import React, { useEffect, useState, useRef } from "react";
import { Layout, Card, Table, DatePicker, Button, Space, Modal } from "antd";
import dayjs from "dayjs";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";

import { getAPI } from "../../../utils/common";
import { KITCHEN_PURCHASE_REPORT } from "../../../constants/api";
import { PROJECT_NAME } from "../../../constants/constent";
import LS_SERVICE from "../../../utils/localStorage";

function KitchenPurchaseReport() {
  const { Content } = Layout;
  const [data, setData] = useState([]);
  const [dates, setDates] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const { company_name } = LS_SERVICE.get("setting") || {};
  const printRef = useRef();

  const fetchData = () => {
    let url = KITCHEN_PURCHASE_REPORT;
    if (dates.length === 2) {
      url += `?date_from=${dates[0]}&date_to=${dates[1]}`;
    }
    getAPI(url, (res) => {
      if (res.status) setData(res.data);
    });
  };

  useEffect(fetchData, []);

  const openModal = (record) => {
    setSelectedSupplier(record);
    setOpen(true);
  };

  const handlePrint = () => {
    if (!printRef.current) return;
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // reload to restore event handlers
  };

  const getPurchaseReturnTotal = (items) => {
    return items.reduce(
      (sum, i) => sum + (i.returned_qty || 0) * (i.rate || 0),
      0,
    );
  };

  const getSupplierReturnTotal = (purchases) => {
    return purchases.reduce((total, p) => {
      return (
        total +
        p.items.reduce(
          (sum, i) => sum + (i.returned_qty || 0) * (i.rate || 0),
          0,
        )
      );
    }, 0);
  };
  const columns = [
    { title: "S.No", render: (_, __, i) => i + 1 },
    { title: "Supplier", dataIndex: "supplier_name" },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      render: (amt) => `₹${amt}`,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button onClick={() => openModal(record)}>View</Button>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Purchase Report"
          extra={
            <Space>
              <DatePicker.RangePicker
                onChange={(v) =>
                  setDates([
                    dayjs(v[0]).format("YYYY-MM-DD"),
                    dayjs(v[1]).format("YYYY-MM-DD"),
                  ])
                }
              />
              <Button type="primary" onClick={fetchData}>
                Filter
              </Button>
            </Space>
          }
        >
          <Table columns={columns} dataSource={data} rowKey={(r, i) => i} />
        </Card>

        <Modal
          open={open}
          onCancel={() => setOpen(false)}
          footer={null}
          width={1400}
          destroyOnClose
        >
          {selectedSupplier && (
            <div ref={printRef}>
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <h2>{company_name || PROJECT_NAME} Kitchen Purchase Report</h2>
                <h3>Supplier: {selectedSupplier.supplier_name}</h3>
                <p>Date: {dayjs().format("YYYY-MM-DD")}</p>
              </div>

              <Card style={{ marginBottom: 20 }}>
                <h3>Total Purchase: ₹{selectedSupplier.total_amount}</h3>
                <h3 style={{ color: "red" }}>
                  Total Return: ₹
                  {getSupplierReturnTotal(selectedSupplier.purchases)}
                </h3>
              </Card>

              {selectedSupplier.purchases.map((purchase) => (
                <div key={purchase.id} style={{ marginBottom: 20 }}>
                  <h4>
                    Purchase #{purchase.id} | Date: {purchase.purchase_date}
                  </h4>
                  <p>Return Total: ₹{getPurchaseReturnTotal(purchase.items)}</p>
                  <Table
                    pagination={false}
                    dataSource={purchase.items}
                    rowKey="id"
                    columns={[
                      { title: "Item Code", dataIndex: ["item", "item_code"] },
                      { title: "Item", dataIndex: ["item", "name"] },

                      {
                        title: "Purchased",
                        dataIndex: "qty",
                      },

                      {
                        title: "Returned",
                        dataIndex: "returned_qty",
                        render: (v) => v || 0,
                      },

                      {
                        title: "Remaining",
                        dataIndex: "remaining_qty",
                        render: (v) => v || 0,
                      },

                      {
                        title: "Rate",
                        dataIndex: "rate",
                        render: (r) => `₹${r}`,
                      },

                      {
                        title: "Total Value",
                        dataIndex: "amount",
                        render: (a) => `₹${a}`,
                      },

                      {
                        title: "Return Value",
                        render: (_, row) =>
                          `₹${(row.returned_qty || 0) * (row.rate || 0)}`,
                      },

                      {
                        title: "Remaining Value",
                        render: (_, row) => (
                          <span style={{ color: "green", fontWeight: 600 }}>
                            ₹{(row.remaining_qty || 0) * (row.rate || 0)}
                          </span>
                        ),
                      },

                      { title: "Expiry", dataIndex: "item_expiry_date" },
                    ]}
                  />
                </div>
              ))}

              <Card>
                <h3>Grand Total: ₹{selectedSupplier.total_amount}</h3>
              </Card>

              <div style={{ textAlign: "right", marginTop: 20 }}>
                <Button type="primary" onClick={handlePrint}>
                  Print Report
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPurchaseReport;
